import maintenance from "@/api/maintenance";

export default {
  state: {},
  mutations: {},
  actions: {
    async checkSystemMaintenance() {
      try {
        let res = await maintenance.show();
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  },
  getters: {}
};
